import React, { useState } from 'react';
import CreateUserForm from '../../components/Forms/CreateUserForm';
import api from '../../services/api';

const UserCreatePage = () => {
  const [formData, setFormData] = useState({
    nome: '',
    cpf: '',
    email: '',
    perfil: '',
    municipio: '',
    regional: ''
  });

  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    console.log(e)
  };

  const handleSubmit = async () => {
    try {
      await api.post('/users/create', formData);
      alert('Registro criado com sucesso!');
      window.location.href = '/user';
    } catch (error) {
      const errorDetail = error.response?.data?.detail || 'Erro desconhecido';
      setErrorMessage(`Erro ao criar o usuário: ${errorDetail}`);
    }
  };

  return (
    <div>
      {errorMessage && (
        <p style={{ color: '#1a1a1a' }}>{errorMessage}</p>
      )}
      <CreateUserForm 
        formData={formData} 
        onChange={handleChange} 
        onSubmit={handleSubmit} 
      />
    </div>
  );
};

export default UserCreatePage;
